import React, { useEffect } from "react";
import { X } from "lucide-react";
import styles from "./CompletionModal.module.css";

const CompletionModal = ({ isOpen, totalPatients, listName = "Patient List", onBackToPatients, onClose }) => {
  // Scroll to top when modal opens
  useEffect(() => {
    if (isOpen) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>

        {/* Close button (X) */}
        <button
          type="button"
          className={styles.closeButton}
          onClick={handleClose}
          aria-label="Close"
        >
          <X size={20} />
        </button>

        {/* Light-blue circle with checkmark */}
        <div className={styles.iconWrapper}>
          <div className={styles.iconCircle}>
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 13L9 17L19 7"
                stroke="#2563EB"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        {/* "All Done!" title */}
        <h2 className={styles.title}>All Done!</h2>

        {/* Message with bold blue "Patient List" */}
        <p className={styles.message}>
          All {totalPatients} patients in{" "}
          <strong className={styles.listName}>{listName}</strong>{" "}
          have been reviewed.
        </p>

        {/* Back button */}
        <button
          type="button"
          className={styles.backButton}
          onClick={onBackToPatients}
        >
          <span className={styles.backArrow}>←</span>
          Back to Patients
        </button>

      </div>
    </div>
  );
};

export default CompletionModal;
